export const PHONE_NUMBER_LENGTH = 10

export enum PeriodString {
  alltime = 'alltime',
  today = 'today',
  yesterday = 'yesterday',
  thisweek = 'thisweek',
  lastWeek = 'lastWeek',
  last10days = 'last10days',
  last30days = 'last30days',
  thismonth = 'thismonth',
  lastmonth = 'lastmonth',
  last3months = 'last3months',
  thisyear = 'thisyear',
  lastyear = 'lastyear',
  custom = 'custom'
}

export const MMS_METER_TYPES: string[] = [
    'MMS-WASION',
    'MMS-CLOU',
    'MMS-MBH',
    'MMS-SECURE',
    'MMS-HEXING',
    'MMS',
    'MMS-CONLOG',
    'MMS-GAMMA',
    'MMS-GEM',
    'MMS-LONGI',
    'MMS-NURI',
    'MMS-HUMANLITECH',
    'MMS-ITRON',
    'CONLOG',
    'MMS-BUTTERFIELD',
    'MMS-BRAINFIELD',
    'MMS-STAR HUYU',
    'MMS-SNEDA',
    'MMS-INEST',
    'MMS-CHINT LUTON ENG',
    'MMS-BUYI EDA CLOVERLAND',
    'MMS-EDA CLOVERLAND',
    'MMS-ITRON-761 SERIES',
    'MMSCLOU',
]

export const PAYMENT_PROVIDER_LABLE_MAP: Record<string, string> = {
    mobilemoney: 'Mobile Money',
    'ghana.gov': 'Pay At Any Bank',
}